import { createEntityClient } from 'shared/channels/entity';
import { issueFormContract } from './issueFormContract';

/** The issue form of the selected project, as served by the service worker. */
export const issueFormClient = createEntityClient(issueFormContract);
